import type {
  KgInsight,
  KgInsightGeoSentiment,
  KgInsightTakeawayTag,
  KgInsightThemeType,
} from '@api/api/kg-insights';
import type { BadgeColor } from '@design/components/badge/Badge';
import semanticColorStyles from '@design/styles/SemanticColor.module.scss';

import sharedStyles from './kg-insight-constants.module.scss';

export type ThemeColor = 'indigo' | 'teal' | 'purple' | 'gold';

export type Sentiment = KgInsight['sentiment'];

export const SENTIMENT_BADGE_COLOR: Record<Sentiment, BadgeColor> = {
  positive: 'success',
  negative: 'error',
  neutral: 'warning',
};

export const GEO_SENTIMENT_BADGE_COLOR: Record<
  KgInsightGeoSentiment,
  BadgeColor
> = {
  positive: 'success',
  negative: 'error',
  warning: 'warning',
  mixed: 'neutral',
};

export const GEO_SENTIMENT_LINEAR_GRADIENT_STYLE_MAP: Record<
  KgInsightGeoSentiment,
  string
> = {
  positive: sharedStyles.cardPositive,
  negative: sharedStyles.cardNegative,
  warning: sharedStyles.cardWarning,
  mixed: sharedStyles.cardWarning,
};

export const SENTIMENT_STYLE_MAP: Record<Sentiment, string> = {
  positive: semanticColorStyles.directionPositive,
  negative: semanticColorStyles.directionNegative,
  neutral: sharedStyles.warning,
};

export type ThemeTagType = 'industry_theme' | 'financial_theme' | 'macro_theme';

export const THEME_TAG_KIND_MAP: Record<
  KgInsightTakeawayTag['kind'],
  ThemeColor
> = {
  industry: 'indigo',
  financial: 'purple',
  macro: 'teal',
};

export const THEME_TAG_COLOR_CLASS_MAP: Record<KgInsightThemeType, string> = {
  industry: semanticColorStyles.themeIndustry,
  financial: semanticColorStyles.themeFinancial,
  macro: semanticColorStyles.themeMacro,
};

export const THEME_FILL_COLOR_CLASS_MAP: Record<KgInsightThemeType, string> = {
  industry: sharedStyles.themeFillIndustry,
  financial: sharedStyles.themeFillFinancial,
  macro: sharedStyles.themeFillMacro,
};
